export const VIEWER_SET_URLS = 'VIEWER_SET_URLS';
